const SAVE_ALL_CONTACTS = "SAVE_ALL_CONTACTS"

export { SAVE_ALL_CONTACTS }